import '../Styles/Footer.css'; // Import the new CSS module

function Footer() {
    return (
        <footer className="footer bg-light text-center text-lg-start">
            <div className="container p-4">
                <div className="row">
                    <div className="col footer-col">
                        <ul className="footer-list">
                            <li><a href="https://www.easy-admin.dk/kontakt" className="footer-link">Kontakt</a></li>
                        </ul>
                    </div>
                    <div className="col footer-col">
                        <ul className="footer-list">
                            <li><a href="#!" className="footer-link">Privacy Policy</a></li>
                        </ul>
                    </div>
                    <div className="col footer-col">
                        <ul className="footer-list">
                            <li><a href="#!" className="footer-link">Terms of Service</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="text-center p-3 footer-bottom">
                <p className='footer-text'>© 2023 Copyright:</p> <a className="footer-bottom-link" href="https://www.easy-admin.dk">Easy-admin.dk</a>
            </div>
        </footer>
    );
}

export default Footer;
